import React from 'react';
import { PropTypes } from 'prop-types';
import { Pie } from 'react-chartjs-2';

const CASHPIE = (props) => {
    const {
        annualResults, selectedFinancing, doughnutSlider, projectState, sgipToggle, resiToggle,
    } = props;

    const doughYears = doughnutSlider;

    const annualUtilityPayment =
        annualResults[doughYears].formattedAnnualBill -
            annualResults[doughYears].annualSolarSavings >
        0
            ? annualResults[doughYears].formattedAnnualBill -
              annualResults[doughYears].annualSolarSavings
            : 0;

    const firstYearNet = doughYears === 1 ? annualResults[1].cumulativeCashSavings : 0;


    const cashVsUtilityPolarRECs = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualSolarSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    firstYearNet,
                    annualResults[doughYears].cashITC,
                    annualResults[doughYears].macrs,
                    annualResults[doughYears].recs.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                ],
                backgroundColor: ['#db4141', '#039E4B', '#ff6384', '#dfff61', '#ffe761', '#FFAC33'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'Solar Value ($)',
            'Yr 1 Net Price ($)',
            'ITC ($)',
            'MACRS ($)',
            'RECs ($)',
        ],
    };

    const cashVsUtilityPolar = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualSolarSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    firstYearNet,
                    annualResults[doughYears].cashITC,
                    annualResults[doughYears].macrs,
                ],
                backgroundColor: ['#db4141', '#61ff9a', '#ff6384', '#dfff61', '#ffe761'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'Solar Value ($)',
            'Yr 1 Net Price ($)',
            'ITC ($)',
            'MACRS ($)',
        ],
    };

    const cashSGIPCAgraph = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualSolarSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    firstYearNet,
                    annualResults[doughYears].cashITC,
                    annualResults[doughYears].macrs,
                    annualResults[doughYears].sgip,
                    annualResults[doughYears].sgipPBI,
                ],
                backgroundColor: ['#db4141', '#61ff9a', '#ff6384', '#dfff61', '#ffe761', '#42f4c8', '#8641f4'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'Solar Value ($)',
            'Yr 1 Net Price ($)',
            'ITC ($)',
            'MACRS ($)',
            'SGIP ($)',
            'SGIP PBI',
        ],
    };
    const cashSMARTgraph = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualSolarSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    firstYearNet,
                    annualResults[doughYears].cashITC,
                    annualResults[doughYears].macrs,
                    annualResults[doughYears].smart,
                    annualResults[doughYears].maStateTaxCredit,
                ],
                backgroundColor: ['#db4141', '#61ff9a', '#ff6384', '#dfff61', '#ffe761', '#42f4c8', '#7abfff'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'Solar Value ($)',
            'Yr 1 Net Price ($)',
            'ITC ($)',
            'MACRS ($)',
            'Smart ($)',
            'MA State Tax Credit',
        ],
    };

    const cashVsUtilityPolarNYResi = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualSolarSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    firstYearNet,
                    annualResults[doughYears].cashITC,
                    annualResults[doughYears].nyserdaRebate,
                    annualResults[doughYears].cashNYAbatement,
                    annualResults[doughYears].nyResiTaxCredit,
                ],
                backgroundColor: ['#db4141', '#61ff9a',
                    '#dfff61', '#ffe761', '#8334eb', '#eb34cc', '#ebb434'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'Solar Value ($)',
            'Yr 1 Net Price ($)',
            'ITC ($)',
            'NYSERDA Rebate',
            'Property Abatement',
            'NY Tax Credit',
        ],
    };
    const cashVsUtilityPolarNYCommercial = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualSolarSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    firstYearNet,
                    annualResults[doughYears].cashITC,
                    annualResults[doughYears].macrs,
                    annualResults[doughYears].nyserdaRebate,
                    annualResults[doughYears].cashNYAbatement,
                ],
                backgroundColor: ['#db4141', '#61ff9a', '#ff6384', '#dfff61', '#ffe761', '#8334eb', '#eb34cc'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'Solar Value ($)',
            'Yr 1 Net Price ($)',
            'ITC ($)',
            'MACRS ($)',
            'NYSERDA Rebate',
            'Property Abatement',
        ],
    };


    let data = null;
    if (projectState === 3 && selectedFinancing === 4) {
        data = cashVsUtilityPolarRECs;
    } else if (projectState === 1 && selectedFinancing === 4 && sgipToggle === true) {
        data = cashSGIPCAgraph;
    } else if (projectState === 2 && selectedFinancing === 4) {
        data = cashSMARTgraph;
    } else if (projectState === 4 && selectedFinancing === 4 && resiToggle) {
        data = cashVsUtilityPolarNYResi;
    } else if (projectState === 4 && selectedFinancing === 4 && resiToggle === false) {
        data = cashVsUtilityPolarNYCommercial;
    } else {
        data = cashVsUtilityPolar;
    }

    return (
        <div>
            {selectedFinancing === 4 ? (
                <li>
                    <Pie
                        height={345}
                        data={data}
                        options={{ maintainAspectRatio: true }}
                    />
                </li>
            ) : null}
        </div>
    );
};

CASHPIE.propTypes = {
    annualResults: PropTypes.object.isRequired,
    projectState: PropTypes.number.isRequired,
    doughnutSlider: PropTypes.number.isRequired,
    selectedFinancing: PropTypes.number.isRequired,
    sgipToggle: PropTypes.bool.isRequired,
    resiToggle: PropTypes.bool.isRequired,
};

export default CASHPIE;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/Graphs/CASHPIE/CASHPIE.js